var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"locator__map"},[_c('GmapMap',{ref:"map",staticStyle:{"width":"100%","height":"100%"},attrs:{"center":_vm.mapCenter,"zoom":_vm.mapZoom}},_vm._l((_vm.markers),function(m,i){return _c('GmapMarker',{key:i,attrs:{"position":m.position,"clickable":true,"draggable":false},on:{"click":function($event){_vm.highlight(m)}}})}))],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3c564ae2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/locator/Map.vue
// module id = null
// module chunks = 